import { useIntl } from 'react-intl';

import Loader from '@/components/Loader';
import { useAppLoadedState } from '@/hooks/store';

import { Banner, Description, Details, LoaderWrapper, PlanButton, PlanName, Wrapper } from './styles';
import { PlanTileProps } from './types';

const PlanTile = ({ banner, planName, details, cta, onClick, theme = 'default' }: PlanTileProps) => {
	const appLoaded = useAppLoadedState();
	const { formatMessage } = useIntl();
	return (
		<Wrapper theme={theme}>
			<Banner theme={theme}>{formatMessage(banner)}</Banner>
			<Description isReady={appLoaded}>
				<PlanName>{planName}</PlanName>
				<Details>{details}</Details>
			</Description>
			{!appLoaded && (
				<LoaderWrapper>
					<Loader color="gray7" />
				</LoaderWrapper>
			)}
			<PlanButton
				backgroundColor={theme === 'limited' ? 'gradientCalmBrand' : 'white'}
				textColor={theme === 'limited' ? 'white' : 'gray7'}
				onPress={onClick}
			>
				{formatMessage(cta)}
			</PlanButton>
		</Wrapper>
	);
};

export default PlanTile;
